module.exports = __webpack_public_path__ + "images/emoji/b.4850ad00402fc9449bba.png";